import {defineStore} from 'pinia';

export const useBreadcrumbStore = defineStore('breadcrumb' , () => {
    const items = ref([]);

    return {
        items,
    };
});
